import { observer } from 'mobx-react';
import { FC } from 'react';
import { toJS } from 'mobx';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import useStore from '@hooks/useStore';

import AccountsPayableCustomTable from '@components/AccountsPayableCustomTable';
import { formattedAmount } from '@utils/format';

import useStyles from './../styles';
import AccountsPayableCustomTools from '@components/AccountsPayableCustomTools';
import AccountsPayableGroupCustomTables from '@components/AccountsPayableGroupCustomTables';

export interface IOperationCompleted {}

const OperationCompleted: FC<IOperationCompleted> = () => {
  const css = useStyles();
  const { accountsPayableLink } = useStore();
  const { fundInfo, accountsPayable, tools } = accountsPayableLink;
  const { getTotalAmount, canProcess, canNotProcess } = accountsPayable;
  const { toolsGroupBy } = tools;

  const canProcessRows = [...toJS(canProcess)];
  const canNotProcessRows = [...toJS(canNotProcess)];
  const rows = [...toJS(canProcess), ...toJS(canNotProcess)];

  const handleAmounts = () => {
    let subTotal = 0;
    for (const ap of rows) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const amount = ap.amount as any;
      const itemAmount = Number(amount);
      subTotal = subTotal + itemAmount;
    }

    let dispersedTotal = 0;
    for (const ap of canProcessRows) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const amount = ap.amount as any;
      const itemAmount = Number(amount);
      dispersedTotal = dispersedTotal + itemAmount;
    }

    const notDispersedTotal = subTotal - dispersedTotal;

    return { subTotal, dispersedTotal, notDispersedTotal };
  };

  return (
    <>
      <div className={css.card}>
        <AccountsPayableCustomTools />
        {toolsGroupBy === '' ? (
          <AccountsPayableCustomTable
            canSelect={false}
            grouped
            group="Dispersiones realizadas"
            statusSuccessLabel="Dispersion realizada"
            rows={canProcessRows}
            groupedTotalRows={canProcessRows.length}
            groupedRowsIds={canProcessRows.map((item) => item.accountPayableId)}
          />
        ) : (
          <AccountsPayableGroupCustomTables
            canSelect={false}
            statusSuccessLabel="Dispersion realizada"
            rows={canProcessRows}
          />
        )}
        <AccountsPayableCustomTable
          canSelect={false}
          grouped
          group="Dispersiones no realizadas"
          statusErrorLabel="No se pudo dispersar"
          rows={canNotProcessRows}
          groupedTotalRows={canNotProcessRows.length}
          groupedRowsIds={canNotProcessRows.map((item) => item.accountPayableId)}
        />
        <Grid container spacing={3} className={css.containerButtons}>
          <Grid item xs={12} md={8} />
          <Grid item xs={12} md={4}>
            <Grid container className={css.containerSubTotals}>
              <Grid item xs={8} md={6}>
                Subtotal
              </Grid>
              <Grid item xs={4} md={6} className={css.subTotals}>
                {formattedAmount(handleAmounts().subTotal, fundInfo.currency)}{' '}
                <span className={css.totalAmountCurrency}>{fundInfo.currency}</span>
              </Grid>
            </Grid>
            <Grid container className={css.containerSubTotals}>
              <Grid item xs={8} md={6}>
                Sin dispersar
              </Grid>
              <Grid item xs={4} md={6} className={css.subTotals}>
                - {formattedAmount(handleAmounts().notDispersedTotal, fundInfo.currency)}{' '}
                <span className={css.totalAmountCurrency}>{fundInfo.currency}</span>
              </Grid>
            </Grid>
            <Grid container className={css.containerAmount} style={{ marginTop: 30 }}>
              <Grid item xs={8} md={6}>
                Total dispersado
              </Grid>
              <Grid item xs={4} md={6} className={css.totalAmountContainer}>
                {formattedAmount(handleAmounts().dispersedTotal, fundInfo.currency)}{' '}
                <span className={css.totalAmountCurrency}>{fundInfo.currency}</span>
              </Grid>
            </Grid>
            <Grid container className={css.refundAmountMessageContainer}>
              <Grid item xs={12}>
                <Typography className={css.refundAmountMessageInfo}>
                  <span className={css.blueBold}>¡Atención!</span> En menos de 24 hrs, se realizará
                  un reembolso a la cuenta origen por el monto total de las facturas que no se
                  pudieron dispersar.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default observer(OperationCompleted);
